// Las cuatro cosas que el buscador necesita de una librería de fechas, que en la home es
// moment 2.29.4 (67 KB para esto).
//
// Los tres formatos que conviven en las URLs de salida, y que NO se pueden confundir:
//   DD/MM/YYYY  lo que se ve en los campos y lo que viaja en _paramFrom
//   DD-MM-YYYY  dateFrom / dateTo de la rama de tren + hotel
//   YYYY-MM-DD  dentro del JSON de `data` de la rama de ocio con Viaje+
// Están los tres aquí para que nadie tenga que acordarse de cuál toca en cada sitio.

/** Hoy, a las 00:00. Todas las comparaciones son por día, nunca por instante. */
export function hoy () {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

export function sumarDias (fecha, dias) {
  const d = new Date(fecha.getTime())
  d.setDate(d.getDate() + dias)
  d.setHours(0, 0, 0, 0)
  return d
}

export function mismoDia (a, b) {
  return Boolean(a) && Boolean(b)
    && a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate()
}

/** Estrictamente antes, comparando sólo el día. */
export function antesDe (a, b) {
  if (!a || !b) return false
  const x = new Date(a.getFullYear(), a.getMonth(), a.getDate())
  const y = new Date(b.getFullYear(), b.getMonth(), b.getDate())
  return x.getTime() < y.getTime()
}

const dos = (n) => String(n).padStart(2, '0')

/** DD/MM/YYYY — lo que se ve en el campo. */
export function formatear (fecha) {
  if (!fecha) return ''
  return dos(fecha.getDate()) + '/' + dos(fecha.getMonth() + 1) + '/' + fecha.getFullYear()
}

/** DD-MM-YYYY — dateFrom y dateTo de la rama de tren + hotel. */
export function formatearGuiones (fecha) {
  if (!fecha) return ''
  return dos(fecha.getDate()) + '-' + dos(fecha.getMonth() + 1) + '-' + fecha.getFullYear()
}

/** YYYY-MM-DD — la fecha de dentro del JSON `data` de la rama de Viaje+. */
export function formatearIso (fecha) {
  if (!fecha) return ''
  return fecha.getFullYear() + '-' + dos(fecha.getMonth() + 1) + '-' + dos(fecha.getDate())
}

/** Lee DD/MM/YYYY. Devuelve null si no cuadra, en vez de una fecha inventada. */
export function parsear (texto) {
  const m = String(texto || '').trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (!m) return null
  const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]))
  d.setHours(0, 0, 0, 0)
  // `new Date(2026, 1, 31)` no falla: se va al 3 de marzo. Hay que comprobarlo.
  if (d.getDate() !== Number(m[1]) || d.getMonth() !== Number(m[2]) - 1) return null
  return d
}
